import { CDN_ASSETS } from './common';

export const FORTUNA_ASSETS = {
  // вроде не используется
  'packages/fortuna-room.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-room.jpg`,
  'packages/fortuna-room@2x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-room@2x.jpg`,
  // вроде не используется
  'packages/fortuna-room@3x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-room@3x.jpg`,

  'packages/fortuna.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna.jpg`,
  'packages/fortuna@2x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna@2x.jpg`,
  'packages/fortuna@3x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna@3x.jpg`,

  'packages/fortuna-2.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-2.jpg`,
  'packages/fortuna-2@2x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-2@2x.jpg`,
  'packages/fortuna-2@3x.jpg': `${CDN_ASSETS}/packages/fortuna/fortuna-2@3x.jpg`,

  'hotels/fortuna.jpg': `${CDN_ASSETS}/hotels/fortuna/fortuna.jpg`,
  'hotels/fortuna@2x.jpg': `${CDN_ASSETS}/hotels/fortuna/fortuna@2x.jpg`,
  'hotels/fortuna@3x.jpg': `${CDN_ASSETS}/hotels/fortuna/fortuna@3x.jpg`,

  'hotels/fortuna-mobile.jpg': `${CDN_ASSETS}/hotels/fortuna/fortuna-mobile.jpg`,
  'hotels/fortuna-mobile@2x.jpg': `${CDN_ASSETS}/hotels/fortuna/fortuna-mobile@2x.jpg`,
  'hotels/fortuna-mobile@3x.jpg': `${CDN_ASSETS}/hotels/fortuna/fortuna-mobile@3x.jpg`,
} as const;
